import { Component, OnChanges, OnInit, AfterViewInit } from "@angular/core";
import { UserService } from "./shared";
import {
  Router,
  NavigationStart,
  NavigationCancel,
  NavigationEnd,
} from "@angular/router";
import { filter } from "rxjs/operators";
declare var gtag;
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
})
export class AppComponent implements OnInit, OnChanges, AfterViewInit {
  currentUser: any;
  loading;
  constructor(private userService: UserService, private router: Router) {
    this.loading = true;
    // Google Analytics code
    const navEndEvent$ = router.events.pipe(
      filter((e) => e instanceof NavigationEnd)
    );
    navEndEvent$.subscribe((e: NavigationEnd) => {
      gtag("config", "G-7EQYDKC8EG");
      gtag("config", "AW-812064834");

      //   if (e.urlAfterRedirects == "/Apply-visa/Tourist-Individual-Confirm") {
      //     //   gtag('event', 'conversion', {
      //     //   'send_to': 'AW-812064834/tZCCCOa9nn8QwsCcgwM',
      //     //   'event_callback': e.urlAfterRedirects
      //     // });
      //   }
      //   if (e.urlAfterRedirects == "/Apply-visa/Business-Individual-Confirm") {
      //     // gtag('event', 'conversion', {
      //     //   'send_to': 'AW-812064834/tZCCCOa9nn8QwsCcgwM',
      //     //   'event_callback': e.urlAfterRedirects
      //     // });
      //   }
    });
  }
  // This method should be deleted in future.
  // This behavior should be handled architecturely using components/modules
  ShowRelevant() {
    return !window.location.pathname.includes("Apply-visa");
  }
  onDeactivate() {
    document.body.scrollTop = 0;
    // Alternatively, you can scroll to top by using this other call:
    // window.scrollTo(0, 0)
  }
  ngOnInit() {
    this.userService.populate();
    this.currentUser = this.userService.getCurrentUser();
    // this.router.navigateByUrl('/' + this.currentUser.landingPage);
  }
  ngOnChanges() {
    this.userService.populate();
  }
  ngAfterViewInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.loading = true;
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel
      ) {
        this.loading = false;
      }
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/user/Desktop/rohini_india/angular/Srilanka-eta.org.lk/src/app/app.component.ts